import { FC } from 'react';

// hooks / apis
import { useUserMutation } from 'api/account';

// material-ui
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

// components
import Button from 'components/Button';

// icons
import BlockIcon from '@material-ui/icons/Block';

type Props = {
  user: User;
  handleChangeSystemAdminList: () => void;
};

export const SystemAdminItem: FC<Props> = ({
  user,
  handleChangeSystemAdminList,
}) => {
  const classes = useStyles();

  const {
    isLoading: adminStateLoading,
    isSuccess: isSubmitSucceeded,
    isError: isSubmitFailed,
    mutate,
  } = useUserMutation({
    onSuccess: () => {
      handleChangeSystemAdminList();
    },
  });

  const restrictSystemAdminAccess = () => {
    if (user?.id) {
      mutate({ ...user, isSystemAdmin: false });
    }
  };

  return (
    <Grid container justifyContent='space-between' alignItems='center'>
      <Grid item xs={10} sm={6}>
        <Typography className={classes.bold}>
          {`${user.firstName} ${user.lastName}`}
        </Typography>
        <Typography className={classes.semibold} color='textSecondary'>
          {user.primaryEmail}
        </Typography>
      </Grid>
      <Grid item xs={2} sm='auto'>
        <Button
          id='restrictSystemAdminButton'
          type='submit'
          onClick={restrictSystemAdminAccess}
          fabIcon={<BlockIcon />}
          color='primary'
          variant='outlined'
          loading={adminStateLoading}
          fail={isSubmitFailed}
          success={isSubmitSucceeded}
        >
          <BlockIcon className={classes.submitButtonIcon} />
          Restrict
        </Button>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  bold: {
    fontWeight: 800,
  },
  semibold: {
    fontWeight: 600,
  },
  submitButtonIcon: {
    marginRight: 10,
  },
});

export default SystemAdminItem;
